import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetObjectByCommentsRequest, GetObjectByCommentsResponse, GetUserCommentsRequest, GetUserCommentsResponse, PostCommentRequest, PostCommentResponse } from './types/TCommentServices';

const URL_Prefix = '/comment';

export const commentService = createApi({
    reducerPath: 'commentService',
    baseQuery: getBaseQuery,
    tagTypes: ['Comment'],
    endpoints: (builder) => ({
        postInterpolationMap: builder.mutation<PostCommentResponse, PostCommentRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Comment'],
        }),
         getUserComment: builder.query<GetUserCommentsResponse, GetUserCommentsRequest>({
              query: (params) => ({
                url: `${URL_Prefix}/get_user_comments/`,
                method: 'GET',
                params: params
              }),
              providesTags: ['Comment'],
            }),
         getObjectByComment: builder.query<GetObjectByCommentsResponse, GetObjectByCommentsRequest>({
              query: (params) => ({
                url: `${URL_Prefix}/get_object_by_comment/${params.comment_uuid}`,
                method: 'GET',
                params: params
              }),
              providesTags: ['Comment'],
            }),
    }),
});

export const {
    usePostInterpolationMapMutation,
    useGetUserCommentQuery,
    useLazyGetUserCommentQuery,
    useGetObjectByCommentQuery,
    useLazyGetObjectByCommentQuery,
} = commentService;